class NewPdpDetails extends HTMLElement {
  connectedCallback() {
    this._tabs = Array.from(this.querySelectorAll("[data-detail-tab]"));
    this._panels = Array.from(this.querySelectorAll("[data-detail-panel]"));
    this._titleList = this.querySelector("[data-detail-title-list]");
    this._description = this.querySelector("[data-detail-description]");
    this._activeTabId = null;

    this._tabs.forEach((tab) => {
      tab.addEventListener("click", () => this._activateTab(tab.dataset.detailTab));
    });

    this._panels.forEach((panel) => {
      panel.querySelectorAll("[data-gallery-trigger]").forEach((thumb, index) => {
        thumb.addEventListener("click", () => this._activateGalleryItem(panel, index));
      });
    });

    if (this._tabs.length > 0) {
      this._activateTab(this._tabs[0].dataset.detailTab);
    }
  }

  _activateTab(tabId) {
    if (!tabId || tabId === this._activeTabId) {
      return;
    }

    this._activeTabId = tabId;

    this._tabs.forEach((tab) => {
      const isActive = tab.dataset.detailTab === tabId;
      tab.classList.toggle("is-active", isActive);
      tab.setAttribute("aria-selected", isActive ? "true" : "false");
    });

    this._panels.forEach((panel) => {
      panel.hidden = panel.dataset.detailPanel !== tabId;
    });

    const activePanel = this._panels.find((panel) => panel.dataset.detailPanel === tabId);
    if (activePanel) {
      this._activateGalleryItem(activePanel, 0);
    }
  }

  _activateGalleryItem(panel, index) {
    const triggers = Array.from(panel.querySelectorAll("[data-gallery-trigger]"));
    const trigger = triggers[index];

    if (!trigger) {
      this._renderTitleList(triggers, -1, panel);
      this._updateDescription("");
      return;
    }

    // Every item's hero is already rendered and loaded, so revealing one is
    // instant — nothing is fetched on click.
    const heroImages = Array.from(panel.querySelectorAll("[data-detail-hero]"));

    heroImages.forEach((heroImage, heroIndex) => {
      const isActive = heroIndex === index;
      heroImage.classList.toggle("is-active", isActive);
      heroImage.setAttribute("aria-hidden", isActive ? "false" : "true");
    });

    triggers.forEach((thumb, thumbIndex) => {
      thumb.classList.toggle("is-active", thumbIndex === index);
      thumb.setAttribute("aria-current", thumbIndex === index ? "true" : "false");
    });

    this._renderTitleList(triggers, index, panel);
    this._updateDescription(trigger.dataset.description);
  }

  _renderTitleList(triggers, activeIndex, panel) {
    if (!this._titleList) {
      return;
    }

    this._titleList.innerHTML = "";

    triggers.forEach((trigger, index) => {
      const title = trigger.dataset.title;

      if (!title) {
        return;
      }

      const item = document.createElement("li");
      item.className = "new-pdp-details__title-item";
      item.textContent = title;

      if (index === activeIndex) {
        item.classList.add("is-active");
      }

      item.addEventListener("click", () => this._activateGalleryItem(panel, index));
      this._titleList.appendChild(item);
    });
  }

  _updateDescription(description) {
    if (!this._description) {
      return;
    }

    this._description.textContent = description || "";
  }
}

if (!window.customElements.get("new-pdp-details")) {
  window.customElements.define("new-pdp-details", NewPdpDetails);
}
